import { render, staticRenderFns } from "./ReportTripDetails.vue?vue&type=template&id=2a55385a&scoped=true"
import script from "./ReportTripDetails.vue?vue&type=script&lang=ts"
export * from "./ReportTripDetails.vue?vue&type=script&lang=ts"
import style0 from "./ReportTripDetails.vue?vue&type=style&index=0&id=2a55385a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a55385a",
  null
  
)

export default component.exports